export default {
    methods: {
        emitData: function() {
            this.$emit('emitChangeModel',this.tmplContent,this.params)
        },
        changeData:function (data) {
            let clone = $.extend(true,{},data)
            this.tmplContent = clone.tmplContent
            this.params = clone.params
            this.codemirrorRefresh()
        },
        stringAnalysis: function(data) {
            let keyList = data.match(this.regex)? data.match(this.regex).map(item=>item.replace(/{{/g, '').replace(/}}/g, '')): []
            let checkedParams = this.getDeduplicatedParams(keyList,this.params)
            this.params = checkedParams.reduce((base,row)=>{
                let doubleChecks = this.params.filter(obj=>(obj.paramType === row.paramType && obj.paramKey === row.paramKey))
                if(doubleChecks.length > 0) {
                    row.paramLen = doubleChecks[0].paramLen
                }
                switch (row.paramType) {
                    case 'T' :
                        row.paramLen = 16
                        break;
                    case 'H' :
                        row.paramLen = 5
                        break;
                    case 'D' :
                        row.paramLen = 10
                        break;
                    case 'm' :
                        row.paramLen = 11
                        break;
                    case 'M' :
                        row.paramLen = 17
                        break;
                    case 'C' :
                        row.paramLen = 6
                        break;
                    case 'c' :
                        row.paramLen = 7
                        break;
                    default :
                        break;
                }
                base = [...base, row]
                return base
            },[])
        },
        getDeduplicatedParams: function(keys,params) {
            return keys.reduce((unique, currKey,idx,base) => {
                if(!unique.checkList.includes(currKey)) {
                    let currKeyParams = currKey.split(':')
                    let result = {
                        paramKey: currKeyParams[0],
                        paramType: currKeyParams[1],
                        duplParamCnt: this.countDuplicatedKey(base,currKey),
                        paramLen: this.getCheckedLength?this.getCheckedLength(params,currKey):null,  // if sms case check length
                        tmplId: this.value.tmplId
                    }
                    unique.results = [...unique.results,result]
                    unique.checkList = [...unique.checkList, currKey]
                }
                return unique
            }, {checkList:[],results:[]}).results.sort((o,n)=>o.paramKey - n.paramKey)
        },
        isParamsDuplicated: function(keys){
            if(!keys) return true
            let flag = false
            let dupl = new Set(keys)
            dupl.forEach((item)=>{
                if(this.countDuplicatedKey(keys,item) > 1) flag = true
            })
            return flag
        },
        countDuplicatedKey: function(base,currKey) {
            return base.filter(x=> x === currKey).length
        },
    }
}
